import { connect } from 'react-redux'
import Cases from './Cases'

const stateToProps = () => ({})

const dispatchToProps = {}

export default connect(stateToProps, dispatchToProps)(Cases)



// WEBPACK FOOTER //
// ./src/pages/Cases/Cases.container.js